import type {
  GetLegacyServicePickersResponse,
  GetPickersResponse,
} from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'

import {
  MACBOOKS_CATEGORIES,
  ProductCategory,
} from '~/scopes/product-core/constants'

import {
  STEP_ILLUSTRATION_AIRPODS,
  STEP_ILLUSTRATION_GENERIC,
  STEP_ILLUSTRATION_IPAD,
  STEP_ILLUSTRATION_LAPTOP,
  STEP_ILLUSTRATION_MACBOOK,
  STEP_ILLUSTRATION_SERVICES,
  STEP_ILLUSTRATION_SMARTPHONE,
} from '../CustomizationFunnel.constants'

import type { DesktopIllustration } from './types'

export const getStepIllustrations = (
  product: GetProductResponse,
  picker:
    | GetPickersResponse['pickerGroups'][number]
    | GetLegacyServicePickersResponse['pickerGroups'][number],
): Record<string, DesktopIllustration> => {
  let variantIllustrations = {}

  if (
    [ProductCategory.SMARTPHONE, ProductCategory.SMARTPHONE_BOX].includes(
      product.tracking.categoryId,
    )
  ) {
    variantIllustrations = {
      ...STEP_ILLUSTRATION_SMARTPHONE,
      dual_sim: {
        src: picker.sideContentV2?.content[0]?.imageUrl,
        position: 'center_center',
      },
    }
  } else if (MACBOOKS_CATEGORIES.includes(product.tracking.categoryId)) {
    variantIllustrations = {
      ...STEP_ILLUSTRATION_MACBOOK,
      mount_type: {
        src: picker.sideContentV2?.content[0]?.imageUrl,
        position: 'center_center',
      },
    }
  } else if (product.tracking.categoryId === ProductCategory.AIRPODS) {
    variantIllustrations = STEP_ILLUSTRATION_AIRPODS
  } else if (product.tracking.categoryId === ProductCategory.APPLE_WATCH) {
    variantIllustrations = {
      ...STEP_ILLUSTRATION_GENERIC,
      case_size: {
        src: picker.sideContentV2?.content[0]?.imageUrl,
        position: 'center_top',
      },
      case_material: {
        src: picker.sideContentV2?.content[0]?.imageUrl,
        position: 'center_bottom',
      },
    }
  } else if (product.tracking.categoryId === ProductCategory.IPAD) {
    variantIllustrations = {
      ...STEP_ILLUSTRATION_GENERIC,
      ...STEP_ILLUSTRATION_IPAD,
    }
  } else if (product.tracking.categoryId === ProductCategory.LAPTOP) {
    variantIllustrations = {
      ...STEP_ILLUSTRATION_GENERIC,
      ...STEP_ILLUSTRATION_LAPTOP,
    }
  } else if (product.tracking.categoryId === ProductCategory.GAMING_CONSOLE) {
    variantIllustrations = {
      ...STEP_ILLUSTRATION_GENERIC,
      edition_type: {
        src: picker.sideContentV2?.content[0]?.imageUrl,
        position: 'center_center',
      },
    }
  } else {
    variantIllustrations = STEP_ILLUSTRATION_GENERIC
  }

  return {
    ...variantIllustrations,
    ...STEP_ILLUSTRATION_SERVICES,
  }
}
